<template>
  <div class="main-simule-aqui">
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="simule-aqui" class="adesao-finalizada">
            <div style="display: block; display: flex; align-items: center; justify-content: center; margin-top: 57px;">
              <h3>Nenhum endereço encontrado!</h3><br>
            </div>
            <div style="display: block; width: 512px; margin: 0 auto; margin-top: 38px!important;">
              <p class="text-adesao-finalizada">Não pudemos encontrar o conteúdo que procura, verifique a URL digitada.</p>
            </div>
            <div style="display: block; margin-top: 63px;">
              <a href="https://svc.aliancaadm.com.br/aplicacoes/servicosonline/" class="link-adesao-finalizada">Acessar área do cliente</a>
            </div>
            <div style="display: block; margin-top: 20px;">
              <a href="https://aliancaadm.com.br/" class="link-adesao-finalizada link-nofocus">Voltar para página inicial</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'Proposta-finalizada',
    mixins: [],
    components: {},
    data(){
      return {
        cep: '',
      }
    },
    methods: {
      
    },
    created() {
      //this.recoveryStep()
    }
  }
</script>
